import React from 'react';
import PropTypes from 'prop-types';
import { catalogItemShape } from './_common_/propTypes';
import TableToolbar from '../ReusableComponents/Table/TableToolbar/TableToolbar';

export default function FnCatalogTableToolbar({
  catalogItems,
  bulkUpdateCatalogItem,
  onClickCheckbox,
  perms,
}) {
  const toolsFunctions = {
    'prop65-add': () => {
      const selectedCatalogItems = catalogItems.filter(
        (item) => item.checked && (!item.prop65 || item.prop65 === false),
      );
      if (selectedCatalogItems.length === 0) return;
      const catalogItemsData = selectedCatalogItems.map((item) => ({
        ...item,
        prop65: true,
      }));
      bulkUpdateCatalogItem(catalogItemsData);
    },
    /* This tool is unused at the moment but could be used again in the future */
    'prop65-remove': () => {
      const selectedCatalogItems = catalogItems.filter(
        (item) => item.checked && (!item.prop65 || item.prop65 === true),
      );
      if (selectedCatalogItems.length === 0) return;
      const catalogItemsData = selectedCatalogItems.map((item) => ({
        ...item,
        prop65: false,
      }));
      bulkUpdateCatalogItem(catalogItemsData);
    },
  };

  const handleToolClick = (tool) => {
    toolsFunctions[tool]();
  };

  return (
    <TableToolbar
      openTools={catalogItems.some((item) => item.checked)}
      onClickCheckbox={onClickCheckbox}
      additionalTools={[
        {
          value: 'prop65-add',
          text: 'Yes Prop65',
          onClick: () => handleToolClick('prop65-add'),
          disabled: !perms.canUpdateProps,
        },
      ]}
    />
  );
}

FnCatalogTableToolbar.propTypes = {
  catalogItems: PropTypes.arrayOf(catalogItemShape).isRequired,
  bulkUpdateCatalogItem: PropTypes.func.isRequired,
  onClickCheckbox: PropTypes.func.isRequired,
  perms: PropTypes.shape({
    canUpdateProps: PropTypes.bool,
  }).isRequired,
};
